import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { Link, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import { useForm } from "react-hook-form";
import LabelledStockForm from "../components/LabelledStockForm";
import { useDispatch, useSelector } from "react-redux";
import { setCategoryList } from "../slices/categorySlice";
import { fetchAllProducts } from "../services/product-service";
import { fetchAllCategories } from "../services/category-service";
import { fetchAllVendors } from "../services/vendor-service";
import { useQuery } from "@tanstack/react-query";
import { setProductList } from "../slices/productSlice";
import { setVendorList } from "../slices/vendorSlice";
import { fetchAllDesigns } from "../services/design-service";
import { setDesignList } from "../slices/designSlice";
import { fetchAllPurities } from "../services/purity-service";
import { setPurityList } from "../slices/puritySlice";
import { fetchAllBranches } from "../services/branch-service";
import { setBranchList } from "../slices/branchSlice";
import { useGetAllVendorsQuery } from "../toolkitServices/vendorApi";
import { useGetAllBranchesQuery } from "../toolkitServices/branchApi";
import { useGetAllCategoriesQuery } from "../toolkitServices/categoryApi";
import { useGetAllProductsQuery } from "../toolkitServices/productApi";
import { useGetAllPuritiesQuery } from "../toolkitServices/purityApi";
import { useGetAllDesignsQuery } from "../toolkitServices/designApi";
import { useGetAllStonesQuery } from "../toolkitServices/stoneApi";
import { setStoneList } from "../slices/stoneSlice";
import UnlabelledStockForm from "../components/UnlabelledStockForm";
import PurchaseStockForm from "../components/PurchaseStockForm";

const CreatePurchaseEntry = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
   const { data: vendors } = useGetAllVendorsQuery({ page: 1, limit: 1000, search: "" });
  const { data: branches } = useGetAllBranchesQuery();
  const { data: categories } = useGetAllCategoriesQuery({ page: 1, limit: 1000, search: "" });
  const { data: products } = useGetAllProductsQuery({ page: 1, limit: 2000, search: "" });
  const { data: designs } = useGetAllDesignsQuery({ page: 1, limit: 2000, search: "" });
  const { data: purities } = useGetAllPuritiesQuery({ page: 1, limit: 1000, search: "" });
  const { data: stones } = useGetAllStonesQuery({ page: 1, limit: 2000, search: "" });



  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    watch,
    control
  } = useForm();


  useEffect(()=>{
     if(categories?.data?.length){
      dispatch(setCategoryList(categories?.data))
     }
     if(products?.data?.length){
      dispatch(setProductList(products?.data))
     }
     if(vendors?.data?.length){
      dispatch(setVendorList(vendors?.data))
     }
      if(designs?.data?.length){
      dispatch(setDesignList(designs?.data))
     }
     if(purities?.data?.length){
      dispatch(setPurityList(purities?.data))
     }
       if(branches?.data?.length){
      dispatch(setBranchList(branches?.data))
     }
      if(stones?.data?.length){
      dispatch(setStoneList(stones?.data))
     }
     
     
  },[categories,products,vendors,designs,purities,branches,stones])

   useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.key === "Backspace") {
        e.preventDefault(); // optional
        navigate(-1); // go back one step in history
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [navigate]);
  
  const onSubmit = (data) => {
    console.log(data)
  };
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className="max-w-8xl mx-auto bg-white shadow-lg rounded-xl px-4 pb-2 pt-1  relative max-h-[89vh] overflow-y-auto"
    >
     
    <PurchaseStockForm
        handleSubmit={handleSubmit}
        register={register}
        onSubmit={onSubmit}
        errors={errors}
        control={control}
      />
    </motion.div>
  );
};

export default CreatePurchaseEntry;
